import Button from '../../../components/Buttons/Button';
import cn from '../../../lib/classNames';

import laptop from './images/laptop.svg';

import styles from './EmpowerYourTeam.module.scss';

type EmpowerYourTeamType = {
	classPageContent?: string;
};

export default function EmpowerYourTeam(props: EmpowerYourTeamType) {
	const { classPageContent } = props;
	return (
		<div className={styles.wrap}>
			<div className={cn(styles.content, classPageContent)}>
				<div className={styles['text-block']}>
					<h3 className={styles.title}>Empower Your Team with Safe-xplore</h3>
					<div className={styles.description}>
						Equip your people with personalized risk intelligence and comprehensive health, safety,
						and security insights for both domestic and international destinations.
					</div>
					<div className={styles['button-wrap']}>
						<Button
							className={cn(styles.button, 'button-book-the-demo')}
							elementType="button"
							variant="filled"
							color="secondary"
							size="large"
							// Disabled due to the Ortto form usage
							// elementType="link"
							// href="https://safe-esteem.typeform.com/to/UVWEowBk"
							// target="_blank"
						>
							Book the demo
						</Button>
					</div>
				</div>
				<div className={styles.image}>
					<img src={laptop} alt="Empower Your Team" />
				</div>
			</div>
		</div>
	);
}
